<template>
  <div>
    <template v-if="documento !== ''">
      <template v-if="formato === 'html'">
        <div class="ven_recibo_email" v-if="tipo === 'recibo'">
          <div>
            <a @click="vendaNumDocEnviarPorEmail">Enviar por E-mail</a>
          </div>
        </div>
        <iframe id="rf-documento-imprimir" :src="'data:text/html;base64,' + documento" style="border: none; width: 100%; height: 100vh;"></iframe>
      </template>
      <template v-else-if="formato === 'pdf'">
        <iframe :src="'data:application/pdf;base64,' + documento" style="border: none; width: 100%; height: 100vh;"></iframe>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .ven_recibo_email {
    padding-right: 17px;
  }
    .ven_recibo_email > div {
      width: 812px;
      border: 1px solid #888;
      margin: auto;
      padding: 2px 5px;
      text-align: right;
    }
      .ven_recibo_email > div > a {
        cursor: pointer;
        color: var(--color-base-03);
        font-size: var(--font-base-soma-10);
        font-family: Verdana,Arial, Helvetica, sans-serif;
      }

  @media print {
    iframe {
      border-top: 1px solid #888;
    }
  }
</style>

<script>
  import { BUSCAR_DOCUMENTO } from '@/assets/js/Funcoes-Iframes.js'

  export default {
    props: {
      cpntId: {
        required: false,
        type: [ String, Number ]
      },
      cpntTipo: {
        required: false,
        type: String
      },
      cpntFormato: {
        required: false,
        type: String,
        default: function () {
          return 'html'
        }
      },
      cpntFechar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        tipo: '',
        registroId: '',
        formato: 'html',
        nome: '',
        print: false,
        documento: ''
      }
    },
    mounted: function () {
      this.vendaNumDocIniciar()
    },
    methods: {
      vendaNumDocIniciar: function () {
        if (this.$route.name === 'abrir_doc_id') {
          // SETA AS INFORMAÇOES DA PAGINA
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'bloquear', value: true }])
        }

        // SETA O STATUS DA PAGINA
        this.vendaNumDocSetarStatusGeral('carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA OS DADOS QUE DEVEM SER SETADOS
        if (this.$route.name === 'abrir_doc_id' && this.$route.params.hasOwnProperty('id') && this.$route.params.hasOwnProperty('tipo')) {
          this.registroId = this.$route.params.id
          this.tipo = this.$route.params.tipo
          this.formato = this.$route.params.formato
          this.nome = this.$route.params.nome
        } else {
          this.registroId = this.cpntId
          this.tipo = this.cpntTipo
          this.formato = this.cpntFormato
          this.nome = this.cpntNome
        }

        // CHAMA A FUNÇÃO PARA BUSCAR O CUPOM NÃO FISCAL NA API
        this.vendaNumDocBuscar()
      },
      vendaNumDocSetarStatusGeral: function (status = '') {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      vendaNumDocBuscar: function () {
        var self = this

        switch (self.nome + '_' + self.tipo) {
          case 'venda_cup-nao-fiscal':
          case 'venda_cup-nao-fiscal_sem_valores':
          case 'venda_cupom':
          case 'venda_cupom_sem_valores':
          case 'dev_cliente_rec-cre-cliente':
          case 'dev_fornecedor_rec-cre-fornecedor':
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          case 'venda_recibo':
            // CHAMA A FUNÇÃO PARA ABRIR O RECIBO
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          case 'venda_cozinha':
          case 'recibo_cozinha':
            // CHAMA A FUNÇÃO PARA ABRIR O RECIBO
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          case 'venda_recibo_sem_valores':
            // CHAMA A FUNÇÃO PARA ABRIR O RECIBO
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          case 'compra_recibo':
            // CHAMA A FUNÇÃO PARA ABRIR O RECIBO
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          case 'comissoes_recibo':
            BUSCAR_DOCUMENTO(self.registroId, self.nome, self.tipo, self.formato, '_self')
            break

          default:
            // eslint-disable-next-line
            console.log(self.nome + '_' + self.tipo)
            self.$store.state.msgWarn('WEB [500]: Erro ao identificar o tipo de documento que deve ser aberto.', 'danger')
            break
        }
      },
      vendaNumDocEnviarPorEmail: function ($event, winWidth = 950, winHeight = 700) {
        // Parametros para carregar no centro da tela
        var tmtMoveWindowX = (screen.width - winWidth ) / 2
        var tmtMoveWindowY = (screen.height - winHeight ) / 2

        var features = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=no,top=' + tmtMoveWindowY + ',left=' + tmtMoveWindowX + ',maximize=no,fullscreen=no,width=' + winWidth + ',height=' + winHeight

        this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/vendas/orc_vis_envia.php?cts=' + this.$store.state.token.cts + '&opcao=1&id=' + this.registroId, 'Enviar Venda', { features: features }, false)
      },
      vendaNumDocAbrir: function (fileName, documento) {
        var self = this

        switch (self.formato) {
          case 'html':
            // CHAMA FUNÇÃO PARA ATUALIZAR INFORMAÇOES DO MENU
            if (self.$route.name === 'abrir_doc_id') {
              self.$store.commit('SET_TITULO_PAGINA', fileName)
            }
            break

          case 'pdf':
            break

          default:
            self.$store.state.msgWarn('WEB [500]: Erro ao identificar o formato de documento que deve ser aberto.', 'danger')
            break
        }

        // SETA O DOCUMENTO RECEBIDO
        self.documento = documento

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (self.print === true) {
          // MANDA IMPRIMIR O CUPOM NÃO FISCAL
          setTimeout(function () {
            // if (self.formato === 'html') {
            //   document.getElementById('rf-documento-imprimir').contentWindow.print()
            // } else {
            // }
            // window.print()

            window.onmouseover = function () {
              window.close()

              if (self.cpntFechar !== null) {
                self.cpntFechar()
              }
            }
          }, 600)
        }
      }
    },
    watch: {
      '$route.name': function () {
        if (this.$route.name === 'abrir_doc_id' && (this.registroId !== this.$route.params.id || this.tipo !== this.$route.params.tipo)) {
          this.vendaNumDocIniciar()
        }
      },
      '$route.params.nome': function () {
        if (this.$route.name === 'abrir_doc_id' && (this.registroId !== this.$route.params.id || this.tipo !== this.$route.params.tipo)) {
          this.vendaNumDocIniciar()
        }
      },
      '$route.params.formato': function () {
        if (this.$route.name === 'abrir_doc_id' && (this.registroId !== this.$route.params.id || this.tipo !== this.$route.params.tipo)) {
          this.vendaNumDocIniciar()
        }
      },
      '$route.params.tipo': function () {
        if (this.$route.name === 'abrir_doc_id' && (this.registroId !== this.$route.params.id || this.tipo !== this.$route.params.tipo)) {
          this.vendaNumDocIniciar()
        }
      },
      '$route.params.id': function () {
        if (this.$route.name === 'abrir_doc_id' && (this.registroId !== this.$route.params.id || this.tipo !== this.$route.params.tipo)) {
          this.vendaNumDocIniciar()
        }
      },
      cpntId: function () {
        this.vendaNumDocIniciar()
      },
      cpntTipo: function () {
        this.vendaNumDocIniciar()
      }
    }
  }
</script>
